import { HttpResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { NgxSpinnerService } from "ngx-spinner";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {
  concatMap,
  debounceTime,
  filter, forkJoin, Observable,
  of,
  ReplaySubject,
  Subscription,
  tap
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  isFirmaSubmitLocked,
  isGeneratePdfReady,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { bloquearSiProcedimientoNoActivo } from 'src/app/_helpers/procedimiento-activo.util';
import { bloquearSiTramiteDadoDeBaja } from 'src/app/_helpers/tramite-baja.util';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ClientFirmaLogService } from 'src/app/_services/client-firma-log.service';
import { ProcedimientosService } from "src/app/_services/procedimientos.service";
import { ServicioGeneral } from "src/app/_services/servicio-general.service";
import { SolicitudEmvsService } from "src/app/_services/solicitud-emvs.service";
import { TokenStorageService } from "src/app/_services/token-storage.service";
import { UserService } from "src/app/_services/user.service";
import { environment } from "src/environments/environment";
import { ClaveService } from "../../_services/clave.service";
import { PdfgenerateServiceEmvs } from "../../_services/pdfgenerateEmvs/pdfgenerateEmvs.service";
import { NavService } from "../../boton-listado/boton-listado.component.service";
import { ConfirmDeleteDialogComponent } from "../../modal/confirm-delete/confirm-delete-dialog.component";
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
import { ListadoTramitesEmvsService } from "../../listado/listado-tramites-emvs/listado-tramites-emvs.service";
import {
  EstadoTramite,
  TramiteEmvs,
} from "../../listado/listado-tramites-emvs/tramite-emvs";
import { DenominacionPuestoElement } from "../../model/denominacionpuesto";
import { OrdenConvocatoriaElement } from "../../model/ordenconvocatoria";
import { SamlRequest } from "../../model/samltoken";
import { PuestoEmvs, SolicitudPuesto } from "./../../model/puestoEmvs";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

declare const AutoScript: any;
declare const Constants: any;

@Component({
  selector: "app-tramite-instancia-general",
  templateUrl: "./tramite-instancia-general.component.html",
  styleUrls: ["./tramite-instancia-general.component.css"],
})
export class TramiteInstanciaGeneralComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {
  procedimiento: any = {};
  currentEnv = environment.environment;
  interested: any = {};
  currentUser: any = this.tokenStorageService.getUser();
  TProvincias: any = [];
  TMunicipios: any = [];
  estadosCiviles: any = [];
  gradosDiscapacidad: any = [];
  gradosDependencia: any = [];
  procedimientosVisibles: any = [];
  solicitudId: string = "";
  representanteId: string = "";
  circustanciaId: string = "";
  unidadId: string;
  activeAddress: any = {};
  municipios: any = this._servicioGeneral.getMunicipios();
  user: any = this._servicioUsuario.getCurrentUserFromServer();
  municipioNombre: string = "";
  submitted: boolean = false;
  isLogged: boolean = false;
  restauraPestania: boolean = true;
  genero: string = "";
  lopd: string = "";
  lastVisitedTab: string = "";
  provincias = this._servicioGeneral.getProvincias();
  ordenConvocatoria: OrdenConvocatoriaElement[] = [];
  denominacionPuesto: DenominacionPuestoElement[] = [];
  arrayAuxPuestos: DenominacionPuestoElement[] = [];
  nombreFilePuesto1: string = "";
  nombreFilePuesto2: string = "";
  submitPuestos: boolean = false;
  submitFamiliar: boolean = false;
  submitAutorizacion: boolean = false;
  submitRepresentante: boolean = false;
  submitInstancia: boolean = false;
  submitConsulta: boolean = false;
  isSigning: boolean = false;
  faltaFirma: boolean = false;
  mapDocumentos: any[] = [];
  arrayFicheros: any[] = [];
  uploadDocuments: boolean = false;
  firmaResultLocked = false;
  TVias: any = [];
  tramite: TramiteEmvs = {
    id: -1,
  };
  mensajeSpinner: string = "Subiendo documentos...";
  representante: any;
  idProcedimiento: number = 1;
  //  @Input() botonListado?: BotonListado;

  selectedOpcion: String = "";
  tabsProcedure1: string[] = [
    "personales-tab",
    "representacionReducida-tab",
    "instancia-tab",
    "politicas-tab",
  ];
  tabsComprobar: string[];
  tabRestoreBehavior = {
    "instancia-tab": () => this.restoreInstancia(),
    "representacionReducida-tab": () => this.restoreRepresentacionReducida(),
    "politicas-tab": () => this.restorePoliticas(),
    "personales-tab": () => this.restorePersonales(),
  };
  distritoId: number;
  vulnerabilidadId: number;
  autorizacionId: number;
  documentosId: number;
  puestoModel: {
    id?: number;
    idDocumento1?: string;
    idDocumento2?: string;
  } = {};
  instanciaId: number;
  subscription: Subscription;
  CSV: any;
  userTk = this.tokenStorageService.getUser()
  isAdmin: boolean = Math.max(...this.userTk["rol"]) > 1;
  constructor(
    private tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private _servicioUsuario: UserService,
    private _notificationI18n: NotificationI18nService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private _router: Router,
    private _serviceProcedimientos: ProcedimientosService,
    private _route: ActivatedRoute,
    private generatePDF: PdfgenerateServiceEmvs,
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _navService: NavService,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    private _clientFirmaLog: ClientFirmaLogService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLogged = !!this.tokenStorageService.getToken();
    console.log(this.idProcedimiento);

    if (!this.isLogged) {
      this._router.navigate(["/login"]);
    }
    this.idProcedimiento = 1;
    this.getProcedimiento();
    this.getNombreMunicipio();
    this.getProvincias();
    this.genero = this.currentUser.genero;

    if (this.currentUser.fechaNacimiento) {
      this.formDatosPersonales.controls["fecha_nacimiento"].patchValue(
        this.formatDate(this.currentUser.fechaNacimiento),
        { emitEvent: false }
      );
    }
    if (this.currentUser.titulacion) {
      this.formDatosPersonales.controls["titulacion"].patchValue(
        this.currentUser.titulacion,
        { emitEvent: false }
      );
    }

    this.getTramiteByUserId(1);
    this.tabsComprobar = this.tabsProcedure1;

    this._solicitudEmvsService.getPoliticas(1)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data != null) {
          this.lopd = data["data"];
        }
      });
    this.subscription = this._navService.navItem$
      .pipe(takeUntil(this.destroy$))
      .subscribe((item) => {
        this.selectedOpcion = item;
        if (this.procedimiento.id == 1) this.onSubmitPoliticas();
      });
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewChecked() {
    if (!this.listadoTramitesService.tramite || this.solicitudId != "") return;

    const tramiteRestaurar = this.listadoTramitesService.tramite;
    if (bloquearSiTramiteDadoDeBaja(
      tramiteRestaurar.estadoFirma,
      this._router,
      this._notificationI18n,
      true
    )) {
      this.listadoTramitesService.tramite = null;
      return;
    }
    const tabId = tramiteRestaurar.lastVisitedTab;
    const tabEl = document.getElementById(tabId);
    if (!tabEl || tabEl.classList.contains("active")) return;

    // Diferir todas las mutaciones de estado al siguiente microtask para que
    // ocurran fuera del CD actual y no provoquen NG0100.
    Promise.resolve().then(() => {
      // Re-comprueba: el flag puede haber cambiado mientras esperamos.
      if (!this.listadoTramitesService.tramite || this.solicitudId != "") return;

      this.lastVisitedTab = tabId;
      this.tramite = tramiteRestaurar;
      this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_RECUPERADO_CON_EXITO');
      this.solicitudId = tramiteRestaurar.id.toString();
      this.tabRestoreBehavior[tabId]();
      this.enableAutoSave();
      tabEl.classList.remove("disabled");
      this.restauraPestania = false;
      tabEl.click();
      tabEl.classList.add("disabled");
      this.listadoTramitesService.tramite = null;
      this._route.queryParams
        .pipe(takeUntil(this.destroy$))
        .subscribe((params) => {
          const rId = params["rId"];
          const accion = params["a"];
          if (rId && accion) {
            this.pdfProcedimientoClave(rId, accion);
          }
        });
    });
  }
  formProcedimiento: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    tramite_id: new FormControl(""),
  });

  formTramite: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    genero: new FormControl(""),
    tramite_id: new FormControl(""),
  });

  formPoliticas: FormGroup = new FormGroup({
    politicas: new FormControl("", Validators.required),
  });

  formCircunstancias: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    pregunta1: new FormControl("", Validators.required),
    pregunta2: new FormControl("", Validators.required),
    pregunta3: new FormControl("", Validators.required),
    pregunta4: new FormControl("", Validators.required),
    pregunta5: new FormControl("", Validators.required),
    pregunta6: new FormControl("", Validators.required),
    pregunta7: new FormControl("", Validators.required),
    pregunta8: new FormControl("", Validators.required),
    pregunta9: new FormControl("", Validators.required),
    pregunta10: new FormControl("", Validators.required),
    pregunta11: new FormControl("", Validators.required),
    pregunta12: new FormControl("", Validators.required),
  });

  formUnidadFamiliar: FormGroup = new FormGroup({
    familiar: new FormArray([
      new FormGroup({
        documento: new FormControl(this.currentUser.numero_documento, [
          Validators.required,
          Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
        ]),
        apellidos_nombre: new FormControl(
          this.currentUser.apellido1 +
          " " +
          this.currentUser.apellido2 +
          " " +
          this.currentUser.nombre,
          Validators.required
        ),
        fecha_nacimiento: new FormControl("", Validators.required),
        parentesco: new FormControl("Solicitante", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        grado_discapacidad: new FormControl("", Validators.required),
        grado_dependencia: new FormControl("", Validators.required),
        tramite: new FormControl(""),
      }),
    ]),
  });

  checkDistritos: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    if (group.get("todas_zonas").value == true) {
      return null;
    } else if (
      group.get("centro").value != "" ||
      group.get("arganzuela").value != "" ||
      group.get("retiro").value != "" ||
      group.get("salamanca").value != "" ||
      group.get("chamartin").value != "" ||
      group.get("tetuan").value != "" ||
      group.get("chamberi").value != "" ||
      group.get("fuencarral_pardo").value != "" ||
      group.get("moncloa").value != "" ||
      group.get("latina").value != "" ||
      group.get("carabanchel").value != "" ||
      group.get("usera").value != "" ||
      group.get("puente_vallecas").value != "" ||
      group.get("moratalaz").value != "" ||
      group.get("ciudad_lineal").value != "" ||
      group.get("hortaleza").value != "" ||
      group.get("villaverde").value != "" ||
      group.get("vallecas_villa").value != "" ||
      group.get("vilcalvaro").value != "" ||
      group.get("san_blas").value != "" ||
      group.get("barajas").value != ""
    ) {
      return null;
    } else {
      return { required: true };
    }
  };

  formDistritos: FormGroup = new FormGroup(
    {
      tramite: new FormControl(""),
      todas_zonas: new FormControl(""),
      centro: new FormControl(""),
      arganzuela: new FormControl(""),
      retiro: new FormControl(""),
      salamanca: new FormControl(""),
      chamartin: new FormControl(""),
      tetuan: new FormControl(""),
      chamberi: new FormControl(""),
      fuencarral_pardo: new FormControl(""),
      moncloa: new FormControl(""),
      latina: new FormControl(""),
      carabanchel: new FormControl(""),
      usera: new FormControl(""),
      puente_vallecas: new FormControl(""),
      moratalaz: new FormControl(""),
      ciudad_lineal: new FormControl(""),
      hortaleza: new FormControl(""),
      villaverde: new FormControl(""),
      vallecas_villa: new FormControl(""),
      vilcalvaro: new FormControl(""),
      san_blas: new FormControl(""),
      barajas: new FormControl(""),
    },
    { validators: this.checkDistritos }
  );

  formVulnerabilidad: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    pregunta1: new FormControl("", Validators.required),
    pregunta2: new FormControl("", Validators.required),
    pregunta3: new FormControl("", Validators.required),
    pregunta4: new FormControl("", Validators.required),
    pregunta5: new FormControl("", Validators.required),
    pregunta6: new FormControl("", Validators.required),
  });

  formAutorizacion: FormGroup = new FormGroup({
    autorizacion: new FormArray([
      new FormGroup({
        tramite: new FormControl(""),
        documento: new FormControl(this.currentUser.numero_documento, [
          Validators.required,
          Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
        ]),
        apellidos_nombre: new FormControl(
          this.currentUser.apellido1 +
          " " +
          this.currentUser.apellido2 +
          " " +
          this.currentUser.nombre,
          Validators.required
        ),
        fecha_nacimiento: new FormControl("", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        parentesco: new FormControl("Solicitante", Validators.required),
      }),
    ]),
  });

  formConsulta: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    dni_nie: new FormControl(""),
    certificado_irpf: new FormControl(""),
    prestaciones_sociales: new FormControl(""),
    familia_numerosa: new FormControl(""),
    discapacidad_dependencia: new FormControl(""),
    titularidad_inmuebles: new FormControl(""),
    empadronamiento: new FormControl(""),
  });

  //    documento_representado: new FormControl("", [this.customPatternValid({ pattern: '^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$', msg: 'TEST CFM'} )]),

  formRepresentante: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    documento_representado: new FormControl("", [
      Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
    ]),
    apellidos_representado: new FormControl("", [
      Validators.pattern("([A-zÀ-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    nombre_representado: new FormControl("", [
      Validators.pattern("([A-zÀ-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    direccion_representado: new FormControl("", [
      Validators.pattern("([A-z0-9._%+-À-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    cp_representado: new FormControl(
      "",
      Validators.pattern("^(?:0[1-9]\\d{3}|[1-4]\\d{4}|5[0-2]\\d{3})$")
    ),
    municipio_representado: new FormControl(""),
    provincia_representado: new FormControl(""),
    email_representado: new FormControl(
      "",
      Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$")
    ),
    telefono1_representado: new FormControl(
      "",
      Validators.pattern("^([9,7,6]{1}[0-9]{8})")
    ),
    telefono2_representado: new FormControl(
      "",
      Validators.pattern("^([9,7,6]{1}[0-9]{8})")
    ),
    nombre1_autorizacion: new FormControl("", [
      Validators.pattern("([A-zÀ-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    nombre2_autorizacion: new FormControl("", [
      Validators.pattern("([A-zÀ-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    dni1_autorizacion: new FormControl("", [
      Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
    ]),
    dni2_autorizacion: new FormControl("", [
      Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
    ]),
  });

  formRepresentanteReducido: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    documento_representado: new FormControl("", [
      Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
    ]),
    apellidos_representado: new FormControl(""),
    nombre_representado: new FormControl("", [
      Validators.pattern("([A-zÀ-ÿ\\s\\u00f1\\u00d1]{1,255})"),
    ]),
    direccion_representado: new FormControl("", [
      Validators.pattern("^([A-zÀ-ÿ\\s\\u00f1\\u00d10-9._%+-]{1,255})"),
    ]),
    cp_representado: new FormControl(
      "",
      Validators.pattern("^(?:0[1-9]\\d{3}|[1-4]\\d{4}|5[0-2]\\d{3})$")
    ),
    municipio_representado: new FormControl(""),
    provincia_representado: new FormControl(""),
    email_representado: new FormControl(
      "",
      Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$")
    ),
    telefono1_representado: new FormControl(
      "",
      Validators.pattern("^([9,7,6]{1}[0-9]{8})")
    ),
    telefono2_representado: new FormControl(
      "",
      Validators.pattern("^([9,7,6]{1}[0-9]{8})")
    ),
    tipo_via_representado: new FormControl(""),
    numero_calle_representado: new FormControl(
      "",
      Validators.pattern("^([0-9]{1,255})")
    ),
    portal_representado: new FormControl(
      "",
      Validators.pattern("^([A-z0-9]{1,255})")
    ),
    escalera_representado: new FormControl(
      "",
      Validators.pattern("^([A-z0-9]{1,255})")
    ),
    planta_representado: new FormControl(
      "",
      Validators.pattern("^([A-z0-9]{1,255})")
    ),
    puerta_representado: new FormControl(
      "",
      Validators.pattern("^([A-z0-9]{1,255})")
    ),
    genero_representado: new FormControl(""),
  });

  formPuestos: FormGroup = new FormGroup({
    documento: new FormControl("", [Validators.required]),
    documento2: new FormControl("", [Validators.required]),
    check1: new FormControl(""),
    puesto: new FormArray([
      new FormGroup({
        convocatoria: new FormControl(""),
        denominacion: new FormControl("", [Validators.required]),
      }),
    ]),
  });

  formDatosPersonales: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    titulacion: new FormControl("", Validators.required),
    fecha_nacimiento: new FormControl("", Validators.required),
    tramite_id: new FormControl(""),
  });

  formFicheros: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    dni_nie: new FormControl(""),
    libro_familia: new FormControl(""),
    separada: new FormControl(""),
    monoparental: new FormControl(""),
    familia_numerosa: new FormControl(""),
    vida_laboral: new FormControl(""),
    funcionario: new FormControl(""),
    movilidad_reducida: new FormControl(""),
    discapacidad: new FormControl(""),
    archivo1: new FormControl(""),
    archivo2: new FormControl(""),
    archivo3: new FormControl(""),
  });

  formInstancia: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    expone: new FormControl("", Validators.required),
    solicita: new FormControl("", Validators.required),
  });

  // formProteccion: FormGroup = new FormGroup({
  //   proteccion: new FormControl("")
  // })

  formatDate(date) {
    const dateFormat = new Date(date);
    let month = "" + (dateFormat.getMonth() + 1);
    let day = "" + dateFormat.getDate();
    let year = dateFormat.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }

  private getUsuario(): void {
    this.currentUser = this.tokenStorageService.getUser();
    if (this.currentUser.email == null) {
      this._router.navigateByUrl("/perfil?action=20");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_COMPLETAR_LOS_DATOS_DE_SU_PERFIL_PARA_PODER_REALIZAR_TRAMITES');
    } else if (this.currentUser.email_confirmado == false) {
      this._router.navigateByUrl("/perfil?action=20");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_VERIFICAR_CUENTA_CORREO');
    }
    this.currentUser.direcciones.forEach((element) => {
      if (element.isActive) {
        this.activeAddress = element;
      }
    });
    this.searchUser(this.currentUser.id);
  }

  private getProcedimiento(): void {
    this._serviceProcedimientos.getProcedimiento(1)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.isAdmin)) {
            return;
          }
          this.procedimiento = procedimiento["Procedimiento"];
        },
        error: (error) => {
          //console.log(error);
        },
      });
    this.getUsuario();
  }

  getTramiteByUserId(idProcedimiento: number) {
    this.listadoTramitesService
      .getTramitesByuserId(this.currentUser.id)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          for (let item of data) {
            if (item.usuario_id.id == this.currentUser.id && !item.custom) {
              if (item.procedimiento_id.id == 1) {
                if (item.estadoFirma == "NO_FINALIZADO") {
                  this.listadoTramitesService.tramite = item;
                } else if (item.estadoFirma == "PENDIENTE_DE_FIRMA") {
                  this._router.navigate(["perfil"], {
                    queryParams: { action: 30 },
                  });
                }
              }
            }
          }
        },
        error: (error) => { },
      });
  }

  getNombreMunicipio(): void {
    this._servicioGeneral
      .getNombreMunicipio(
        this.activeAddress.province.id,
        this.activeAddress.municipality
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          return (this.municipioNombre = data.nombre);
        },
        error: (error) => {
          //console.log(error);
        },
      });
  }

  searchUser(id: number): void {
    this._servicioGeneral.getUserId(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.currentUser = data.Usuario;
          this.tokenStorageService.setUser(data.Usuario, data.usuarioRepresenta);
        },
        error: (error) => {
          //console.log(error);
        },
      });
  }

  getProvincias() {
    return this._servicioGeneral.getProvincias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.TProvincias = data["Provincia"];
      });
  }

  onChangeProvincia(event: Event) {
    this.TProvincias = [];
    const id = (event.target as HTMLInputElement).value;
    this.getProvinciasByID(id);
  }

  getProvinciasByID(id: string) {
    this.provincias
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        data["Provincia"].forEach((provincia) => {
          if (provincia.ccaa["id"] == id) {
            this.TProvincias.push(provincia);
            return this.TProvincias;
          }
        });
      });
  }

  onChangeMunicipio(event: Event) {
    this.TMunicipios = [];
    const id = (event.target as HTMLInputElement).value;
    this.getMunicipiosByID(id);
  }

  getMunicipiosByID(id: string) {
    this.municipios
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        data["Municipio"].forEach((municipio) => {
          if (municipio.municipioPK["provincia"] == id) {
            this.TMunicipios.push(municipio);
            return this.TMunicipios;
          }
        });
      });
  }

  getVias() {
    return this._servicioGeneral.getTipoVias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.TVias = data["TipoVia"];
      });
  }

  getProcedimientos() {
    return this._serviceProcedimientos.getProcedimientos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.procedimientosVisibles = data["Procedimiento"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }


  getGradoDiscapacidad() {
    return this._servicioGeneral.getGradoDiscapacidad()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.gradosDiscapacidad = data["grados_discapacidad"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getGradoDependencia() {
    return this._servicioGeneral.getGradoDependencia()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.gradosDependencia = data["grados_dependencia"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getOrdenConvocatoria() {
    return this._solicitudEmvsService.getOrdenConvocatoria()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.ordenConvocatoria = data.orden_convocatoria;
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getDenominacionPuesto() {
    return this._solicitudEmvsService.getDenominacionPuesto()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.denominacionPuesto = data.denominacion_puesto;
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  onSubmitTramite(): any {
    this.submitted = true;


    this.formProcedimiento.controls["procedimiento_id"].patchValue(
      this.procedimiento.id,
      { emitEvent: false }
    );
    if (this.solicitudId != null && this.solicitudId != undefined)
      this.formProcedimiento.controls["tramite_id"].patchValue(
        this.solicitudId,
        { emitEvent: false }
      );
    this._solicitudEmvsService
      .saveTramite(this.formProcedimiento.value)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (data) => {
          this.solicitudId = data.tramite.id;
          this.tramite = data.tramite;
          if (this.procedimiento.id == 2) {
            this._solicitudEmvsService
              .updateLastVisitedTab({
                id: +this.solicitudId,
                lastVisitedTab: (this.lastVisitedTab = "representacion-tab"),
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe(() => { });
            document
              .getElementById("representacion-tab")
              .classList.remove("disabled");
            //this.getVias();
            this.restauraPestania = false;
            document.getElementById("representacion-tab").click();
            document
              .getElementById("representacion-tab")
              .classList.add("disabled");
          }
          if (this.procedimiento.id == 1) {
            this._solicitudEmvsService
              .updateLastVisitedTab({
                id: +this.solicitudId,
                lastVisitedTab: (this.lastVisitedTab =
                  "representacionReducida-tab"),
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe(() => { });
            document
              .getElementById("representacionReducida-tab")
              .classList.remove("disabled");
            this.getVias();
            this.restauraPestania = false;
            document.getElementById("representacionReducida-tab").click();
            document
              .getElementById("representacionReducida-tab")
              .classList.add("disabled");
          }
        },
      });

    this.enableAutoSave();
  }

  onSubmitDatos(): any {
    this.submitted = true;

    if (
      this.formDatosPersonales.get("fecha_nacimiento")?.hasError("required")
    ) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.LA_FECHA_DE_NACIMIENTO_ES_OBLIGATORIA', 5000);
      this.formDatosPersonales.controls["fecha_nacimiento"].setErrors({
        incorrect: true,
      });
      return false;
    }

    if (this.formDatosPersonales.get("titulacion")?.hasError("required")) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.LA_TITULACION_ES_OBLIGATORIA', 5000);
      this.formDatosPersonales.controls["titulacion"].setErrors({
        incorrect: true,
      });
      return false;
    }
    this.formDatosPersonales.controls["procedimiento_id"].patchValue(
      this.procedimiento.id,
      { emitEvent: false }
    );

    if (this.solicitudId != null && this.solicitudId != undefined)
      this.formDatosPersonales.controls["tramite_id"].patchValue(
        this.solicitudId,
        { emitEvent: false }
      );
    this._solicitudEmvsService
      .saveTramite(this.formDatosPersonales.value)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (data) => {
          this.getOrdenConvocatoria();
          this.getDenominacionPuesto();
          this.solicitudId = data.tramite.id;
          this.tramite = data.tramite;

          this.currentUser = data.tramite.usuario_id;
          this.searchUser(data.tramite.usuario_id.id);
          this._solicitudEmvsService
            .updateLastVisitedTab({
              id: +this.solicitudId,
              lastVisitedTab: (this.lastVisitedTab = "puestos-tab"),
            })

            .pipe(takeUntil(this.destroy$))
            .subscribe(() => { });
          document.getElementById("puestos-tab").classList.remove("disabled");
          this.restauraPestania = false;
          document.getElementById("puestos-tab").click();
          document.getElementById("puestos-tab").classList.add("disabled");
        },
      });

    this.enableAutoSave();
  }

  onSubmitRepresentado(): any {
    this.submitRepresentante = true;

    if (this.procedimiento.id == 1) {
      if (
        this.formRepresentanteReducido
          .get("email_representado")
          ?.hasError("pattern")
      ) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CORREO_ELECTRONICO_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentanteReducido.controls["email_representado"].setErrors(
          { incorrect: true }
        );
        return false;
      }
      if (
        this.formRepresentanteReducido
          .get("cp_representado")
          ?.hasError("pattern")
      ) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_POSTAL_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentanteReducido.controls["cp_representado"].setErrors({
          incorrect: true,
        });
        return false;
      }

      if (
        this.formRepresentanteReducido
          .get("documento_representado")
          ?.hasError("pattern")
      ) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_NUMERO_DE_DOCUMENTO_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentanteReducido.controls[
          "documento_representado"
        ].setErrors({ incorrect: true });
        return false;
      }

      if (!this.formRepresentanteReducido.valid) {
        this._notificationI18n.warning('NOTIFICATION.MESSAGE.SI_DESEA_REALIZAR_EL_TRAMITE_A_TRAVES_DE_UN_REPRESENTANTE_DEBE_RELLENAR_TODOS_LO', 5000);
        return false;
      } else {
        this.formRepresentanteReducido.controls["tramite"].patchValue(
          { id: this.solicitudId },
          { emitEvent: false }
        );

        if (
          this.formRepresentanteReducido.controls["provincia_representado"]
            .value &&
          this.formRepresentanteReducido.controls[
            "provincia_representado"
          ]?.value
            ?.toString()
            .match("[0-9]{1,2}")
        ) {
          this.formRepresentanteReducido.controls[
            "provincia_representado"
          ].setValue(
            {
              id: this.formRepresentanteReducido.controls[
                "provincia_representado"
              ].value,
              nombre: this.TProvincias.find(
                (value) =>
                  value.id ==
                  this.formRepresentanteReducido.controls[
                    "provincia_representado"
                  ].value
              ).nombre,
            },
            { emitEvent: false }
          );
        } else {
          this.formRepresentanteReducido.controls[
            "provincia_representado"
          ].patchValue(null, { emitEvent: false });
        }

        if (
          this.formRepresentanteReducido.controls["tipo_via_representado"]
            .value &&
          this.formRepresentanteReducido.controls[
            "tipo_via_representado"
          ]?.value
            ?.toString()
            .match("[0-9]{1,4}")
        ) {
          this.formRepresentanteReducido.controls[
            "tipo_via_representado"
          ].setValue(
            {
              id: this.formRepresentanteReducido.controls[
                "tipo_via_representado"
              ].value,
              descripcion: this.TVias.find(
                (value) =>
                  value.id ==
                  this.formRepresentanteReducido.controls[
                    "tipo_via_representado"
                  ].value
              ).descripcion,
            },
            { emitEvent: false }
          );
        } else {
          this.formRepresentanteReducido.controls[
            "tipo_via_representado"
          ].patchValue(null, { emitEvent: false });
        }

        this._solicitudEmvsService
          .saveRepresentado({
            ...this.formRepresentanteReducido.value,
            id: this.representanteId,
          })

          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: async (data) => {
              /* if (this.formRepresentanteReducido.controls['municipio_representado'].value) {
              this.formRepresentanteReducido.controls['municipio_representado'].setValue(
                { id: this.formRepresentanteReducido.controls['municipio_representado'].value, nombre: this.TMunicipios.find(value => value.municipioPK.municipio_id == this.formRepresentanteReducido.controls['municipio_representado'].value
                ).nombre }, { emitEvent: false });
            }*/
              this._solicitudEmvsService
                .updateLastVisitedTab({
                  id: +this.solicitudId,
                  lastVisitedTab: (this.lastVisitedTab = "instancia-tab"),
                })

                .pipe(takeUntil(this.destroy$))
                .subscribe(() => { });
              this.representanteId = data["id"];
              document
                .getElementById("instancia-tab")
                .classList.remove("disabled");
              this.restauraPestania = false;
              document.getElementById("instancia-tab").click();
              document
                .getElementById("instancia-tab")
                .classList.add("disabled");
            },
            error: (error) => { },
          });
      }
    }

    if (this.procedimiento.id == 2) {
      if (
        this.formRepresentante.get("email_representado")?.hasError("pattern")
      ) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CORREO_ELECTRONICO_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentante.controls["email_representado"].setErrors({
          incorrect: true,
        });
        return false;
      }

      if (
        this.formRepresentante
          .get("documento_representado")
          ?.hasError("pattern")
      ) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_NUMERO_DE_DOCUMENTO_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentante.controls["documento_representado"].setErrors({
          incorrect: true,
        });
        return false;
      }

      if (this.formRepresentante.get("cp_representado")?.hasError("pattern")) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_POSTAL_DEL_REPRESENTADO_NO_ES_CORRECTO', 5000);
        this.formRepresentanteReducido.controls["cp_representado"].setErrors({
          incorrect: true,
        });
        return false;
      }

      if (!this.formRepresentante.valid) {
        this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
        return false;
      } else {
        if (this.formRepresentante.controls["provincia_representado"].value) {
          this.formRepresentante.controls["provincia_representado"].setValue(
            {
              id: this.formRepresentante.controls["provincia_representado"]
                .value,
              nombre: this.TProvincias.find(
                (value) =>
                  value.id ==
                  this.formRepresentante.controls["provincia_representado"]
                    .value
              ).nombre,
            },
            { emitEvent: false }
          );
        } else {
          this.formRepresentante.controls["provincia_representado"].patchValue(
            null,
            { emitEvent: false }
          );
        }

        if (this.mapDocumentos.length != 0) {
          this.uploadDocuments = true;
          this._notificationI18n.info('NOTIFICATION.MESSAGE.SUBIENDO_DOCUMENTOS', 5000);
          this.mostrarSpinnerMsg("Subiendo documentos...");
        }
        this.formRepresentante.controls["tramite"].patchValue(
          { id: this.solicitudId },
          { emitEvent: false }
        );
        this._solicitudEmvsService
          .saveRepresentado({
            ...this.formRepresentante.value,
            id: this.representanteId,
            tramite: { id: this.solicitudId },
          })

          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: async (data) => {
              /* if (this.formRepresentante.controls['municipio_representado'].value) {
              this.formRepresentante.controls['municipio_representado'].setValue({ id: this.formRepresentante.controls['municipio_representado'].value, nombre: this.TMunicipios.find(value => value.municipioPK.municipio_id == this.formRepresentante.controls['municipio_representado'].value).nombre }, { emitEvent: false });
            }*/
              this.representanteId = data["id"];
              this._solicitudEmvsService
                .saveDocumentosAdjuntos(this.mapDocumentos)

                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: async (data) => {
                    this._solicitudEmvsService
                      .updateLastVisitedTab({
                        id: +this.solicitudId,
                        lastVisitedTab: (this.lastVisitedTab =
                          "circunstancias-tab"),
                      })

                      .pipe(takeUntil(this.destroy$))
                      .subscribe(() => { });
                    this.uploadDocuments = false;
                    document
                      .getElementById("circunstancias-tab")
                      .classList.remove("disabled");
                    this.restauraPestania = false;
                    this.ocultarSpinner();
                    document.getElementById("circunstancias-tab").click();
                    document
                      .getElementById("circunstancias-tab")
                      .classList.add("disabled");
                  },
                  error: (error) => {
                    this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                    this.ocultarSpinner();
                    this._router.navigate(["/inicio"]);
                  },
                });
            },
            error(error) {
              this.ocultarSpinner();
            },
          });
      }
    }
  }


  onSubmitDistritos(): any {
    if (!this.formDistritos.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      this.formDistritos.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );
      this._solicitudEmvsService
        .saveDistritos({ ...this.formDistritos.value, id: this.distritoId })

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            this._solicitudEmvsService
              .updateLastVisitedTab({
                id: +this.solicitudId,
                lastVisitedTab: (this.lastVisitedTab = "vulnerabilidad-tab"),
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe(() => { });
            document
              .getElementById("vulnerabilidad-tab")
              .classList.remove("disabled");
            this.restauraPestania = false;
            document.getElementById("vulnerabilidad-tab").click();
            document
              .getElementById("vulnerabilidad-tab")
              .classList.add("disabled");
          },
        });
    }
  }

  onSubmitVulnerabilidad(): any {
    if (!this.formVulnerabilidad.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      this.formVulnerabilidad.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );
      this._solicitudEmvsService
        .saveVulnerabilidad({
          ...this.formVulnerabilidad.value,
          id: this.vulnerabilidadId,
        })

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            this._solicitudEmvsService
              .updateLastVisitedTab({
                id: +this.solicitudId,
                lastVisitedTab: (this.lastVisitedTab = "ficheros-tab"),
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe(() => { });
            document
              .getElementById("ficheros-tab")
              .classList.remove("disabled");
            this.restauraPestania = false;
            document.getElementById("ficheros-tab").click();
            document.getElementById("ficheros-tab").classList.add("disabled");
          },
        });
    }
  }


  onFileChange(event, key: string) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.size > 15728640) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_SUPERA_LOS_15MB', 5000);
        this.formDatosPersonales.controls["key"].setErrors({ incorrect: true });
      }
      this.formPuestos.controls[key].setValue(file, { emitEvent: false });
    }
  }

  onFileChangeFicheros(event, key: string) {
    const file = event.target.files[0];

    this.convertFile(file)
      .pipe(takeUntil(this.destroy$))
      .subscribe((base64) => {
        let document = {
          key: key,
          nameDocument: event.target.files[0].name,
          typeDocument: event.target.files[0].type,
          b64Document: base64,
          tramite: this.solicitudId,
          id: this.documentosId,
        };
        this.arrayFicheros.push(document);
      });
  }

  onSubmitPoliticas(): any {
    //  this.botonListado.selectedOpcion;
    this.isSigning = true;
    let lopdChecked = this.formPoliticas.controls["politicas"].value;

    if (lopdChecked) {
      if (this.selectedOpcion == "Firmar con Autofirma") {
        this.mostrarSpinnerMsg("Solicitando firma...");

        this._servicioGeneral.generatePdf(this.tramite.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: async (data: any) => {
              if (isGeneratePdfReady(data)) {
                this.CSV = data.csv;
                this._clientFirmaLog.iniciada(this.solicitudId, 'tramite-instancia-general');
                this.singFile(data.file);
              } else if (data?.responseCode === '632') {
                this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_INTENTELO_DE_NUEVO_MAS_TARDE_POR_FAVOR', 5000);
                this.isSigning = false;
                this.ocultarSpinner();
                this._router.navigate(["/inicio"]);
              } else {
                this._notificationI18n.errorPdfGeneration(data, 5000);
                this.isSigning = false;
                this.ocultarSpinner();
              }
            },
            error: (error) => {
              console.error(error);
              this.ocultarSpinner();
            },
          });
      } else {
        this._claveService.iniciaFirma(this.tramite.id, 1)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: async (data: SamlRequest) => {
              this.post(data.nodeService, {
                SAMLRequest: data.SamlRequest,
                RelayState: data.RelayState,
              });
            },
            error: (error) => console.error(error),
          });
      }
      //}
    } else {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_PUEDE_FINALIZAR_EL_TRAMITE_SIN_ACEPTAR_LAS_POLITICAS', 5000);
      this.isSigning = false;
      this.uploadDocuments = false;
    }
  }

  onSubmitPuestos(): any {
    this.submitPuestos = true;

    if (!this.formPuestos.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      if (
        this.formPuestos.controls["check1"].value == "" ||
        this.formPuestos.controls["check1"].value == "false"
      ) {
        this._notificationI18n.warning('NOTIFICATION.MESSAGE.ES_OBLIGATORIO_MARCAR_LA_CASILLA_DE_CONFIRMACION', 5000);
        return false;
      }

      this.uploadDocuments = true;
      let puestos: SolicitudPuesto[] = [];

      this.puesto.value.forEach((item) => {
        let denominacion;
        if (typeof item.denominacion === "object") {
          denominacion = item.denominacion;
        } else {
          denominacion =
            this.denominacionPuesto.find(
              (value) => value.id == item.denominacion
            ) ?? this.denominacionPuesto[0];
        }
        item.denominacion = {
          id: denominacion.id,
          nombre: denominacion.nombre,
          puesto: denominacion.puesto,
        };
        puestos.push(item);
      });

      let puestoEmvs = new PuestoEmvs(
        puestos,
        { id: this.solicitudId },
        this.puestoModel.id,
        this.puestoModel.idDocumento1,
        this.puestoModel.idDocumento2
      );
      this._solicitudEmvsService.savePuesto(puestoEmvs)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            const formData = new FormData();
            var campoDocumento1 =
              this.formPuestos.controls["documento"].value instanceof File
                ? "documento"
                : "idDocumento";
            var campoDocumento2 =
              this.formPuestos.controls["documento2"].value instanceof File
                ? "documento2"
                : "idDocumento2";

            formData.append(
              campoDocumento1,
              this.formPuestos.controls["documento"].value instanceof File
                ? this.formPuestos.controls["documento"].value
                : this.puestoModel?.idDocumento1
            );
            formData.append(
              campoDocumento2,
              this.formPuestos.controls["documento2"].value instanceof File
                ? this.formPuestos.controls["documento2"].value
                : this.puestoModel?.idDocumento2
            );
            formData.append("idPuesto", data.id);
            this._notificationI18n.info('NOTIFICATION.MESSAGE.SUBIENDO_DOCUMENTOS', 5000);
            this.mostrarSpinnerMsg("Subiendo documentos...");

            this._solicitudEmvsService.saveFilePuestos(formData)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (data) => {
                  this._solicitudEmvsService
                    .updateLastVisitedTab({
                      id: +this.solicitudId,
                      lastVisitedTab: (this.lastVisitedTab = "politicas-tab"),
                    })

                    .pipe(takeUntil(this.destroy$))
                    .subscribe(() => { });
                  document
                    .getElementById("politicas-tab")
                    .classList.remove("disabled");
                  this.restauraPestania = false;
                  this.ocultarSpinner();
                  document.getElementById("politicas-tab").click();
                  document
                    .getElementById("politicas-tab")
                    .classList.add("disabled");
                  this.uploadDocuments = false;
                },
                error: (error) => {
                  this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_INTENTELO_DE_NUEVO_MAS_TARDE_POR_FAVOR', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/inicio"]);
                },
              });
          },
        });
    }
  }

  onSubmitInstancia(): any {
    this.submitInstancia = true;

    if (!this.formInstancia.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);

      return false;
    } else {
      this.uploadDocuments = true;
      this.formInstancia.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );

      //if(!this.faltaFirma){
      const solicitudEmvs = {
        ...this.formInstancia.value,
        id: this.instanciaId,
      };

      console.log(solicitudEmvs);

      this._solicitudEmvsService
        .saveInstancia({ ...this.formInstancia.value, id: this.instanciaId })

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            console.log(data);

            if (this.mapDocumentos.length != 0) {
              this._notificationI18n.info('NOTIFICATION.MESSAGE.SUBIENDO_DOCUMENTOS', 5000);
              this.mostrarSpinnerMsg("Subiendo documentos...");
            }

            this.mapDocumentos.forEach((documento) => {
              documento["tramite"] = this.tramite.id;
            });

            console.log(this.mapDocumentos.length);

            this._solicitudEmvsService
              .saveDocumentosAdjuntos(
                this.mapDocumentos && this.mapDocumentos.length > 0
                  ? this.mapDocumentos
                  : [{ tramite: this.tramite.id }]
              )

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: async (data) => {
                  this.uploadDocuments = false;

                  this._solicitudEmvsService
                    .updateLastVisitedTab({
                      id: +this.solicitudId,
                      lastVisitedTab: (this.lastVisitedTab = "politicas-tab"),
                    })

                    .pipe(takeUntil(this.destroy$))
                    .subscribe(() => { });
                  document
                    .getElementById("politicas-tab")
                    .classList.remove("disabled");
                  this.restauraPestania = false;
                  this.ocultarSpinner();
                  document.getElementById("politicas-tab").click();
                  document
                    .getElementById("politicas-tab")
                    .classList.add("disabled");
                },
                error: (error) => {
                  this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/inicio"]);
                },
              });
          },
          error: (error) => {
            console.error(error);
          },
        });
    }
  }

  get puesto(): FormArray {
    return this.formPuestos.get("puesto") as FormArray;
  }

  get autorizacion(): FormArray {
    return this.formAutorizacion.get("autorizacion") as FormArray;
  }

  addPuesto() {
    this.puesto.push(
      new FormGroup({
        convocatoria: new FormControl(""),
        denominacion: new FormControl("", [Validators.required]),
      })
    );
  }

  deletePuesto() {
    this.puesto.removeAt(this.puesto.length - 1);
    this.addPuestoArray();
  }

  deleteFamiliar() {
    const familiar = this.familiar.value[this.familiar.length - 1];
    this.familiar.removeAt(this.familiar.length - 1);
    this._solicitudEmvsService
      .deleteFamiliarById(familiar.id)

      .pipe(takeUntil(this.destroy$))
      .subscribe(() => { });
  }

  deleteAutorizacion() {
    const autorizacion = this.autorizacion.value[this.autorizacion.length - 1];
    this.autorizacion.removeAt(this.autorizacion.length - 1);
    this._solicitudEmvsService
      .deleteAutorizacionById(autorizacion.id)

      .pipe(takeUntil(this.destroy$))
      .subscribe(() => { });
  }

  addAutorizacion() {
    this.autorizacion.push(
      new FormGroup({
        tramite: new FormControl(""),
        documento: new FormControl("", [
          Validators.required,
          Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
        ]),
        apellidos_nombre: new FormControl("", Validators.required),
        fecha_nacimiento: new FormControl("", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        parentesco: new FormControl("", Validators.required),
      })
    );
  }

  get familiar(): FormArray {
    return this.formUnidadFamiliar.get("familiar") as FormArray;
  }

  addFamiliar() {
    this.familiar.push(
      new FormGroup({
        documento: new FormControl("", [
          Validators.required,
          Validators.pattern("^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$"),
        ]),
        apellidos_nombre: new FormControl("", Validators.required),
        fecha_nacimiento: new FormControl("", Validators.required),
        parentesco: new FormControl("", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        grado_discapacidad: new FormControl("", Validators.required),
        grado_dependencia: new FormControl("", Validators.required),
        tramite: new FormControl(""),
      })
    );
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(
        Constants.URL_BASE_SERVICES +
        "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES +
        "/afirma-signature-retriever/RetrieveService"
      );
      AutoScript.sign(
        data != undefined && data != null && data != "" ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.solicitudId, 'tramite-instancia-general');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO');
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById("certifcado") as HTMLInputElement).value = certB64;
    (document.getElementById("result") as HTMLInputElement).value = filenameB64;
    (document.getElementById("error") as HTMLInputElement).value = "";
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.solicitudId, 'tramite-instancia-general', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById("certifcado") as HTMLInputElement).value = "";
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve";

    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }

  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;

    let base64Document = (document.getElementById("result") as HTMLInputElement)
      .value;
    let errorFirma = (document.getElementById("error") as HTMLInputElement)
      .value;

    let certificado = atob(
      (document.getElementById("certifcado") as HTMLInputElement).value
    );

    if (
      certificado.includes(
        this.tokenStorageService.getUser().numero_documento
      ) ||
      certificado == ""
    ) {
      if (this.procedimiento.id == 1) {
        this.formInstancia.addControl("pdfFirmado", new FormControl(), {
          emitEvent: false,
        });
        this.pdfProcedimiento(errorFirma, base64Document, this.formInstancia);
      } else if (this.procedimiento.id == 2) {
        this.formConsulta.addControl("pdfFirmado", new FormControl(), {
          emitEvent: false,
        });
        this.pdfProcedimiento(errorFirma, base64Document, this.formConsulta);
      } else if (this.procedimiento.id == 3) {
        this.formPoliticas.addControl("pdfFirmado", new FormControl(), {
          emitEvent: false,
        });
        this.pdfProcedimiento(errorFirma, base64Document, this.formPoliticas);
      }
    } else {
      releaseFirmaSubmitLock(this);
      this.faltaFirma = true;
      this.isSigning = false;
      this.submitInstancia = false;
      this.submitConsulta = false;
      this._servicioUsuario
        .clearCurrentTipoFirma()

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      this._clientFirmaLog.certificadoInvalido(this.solicitudId, 'tramite-instancia-general');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
    }
  }

  public pdfProcedimiento(
    errorFirma: string,
    base64Document: string,
    formDoc: FormGroup
  ) {
    if (this.uploadDocuments) {
      return;
    }
    this.ocultarSpinner();
    if (errorFirma == "" && base64Document != "") {
      this._clientFirmaLog.exito(this.solicitudId, 'tramite-instancia-general');
      this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');

      formDoc.controls["pdfFirmado"].setValue(
        {
          nameDocument: "comprobante_solicitud_tramite_.pdf",
          typeDocument: "application/pdf",
          b64Document: base64Document,
          csv: this.CSV,
        },
        { emitEvent: false }
      );
      this.downloadPdf(base64Document, "comprobante_solicitud_tramite");
      this.uploadDocuments = true;
      this._solicitudEmvsService
        .savePdf(formDoc.controls["pdfFirmado"].value, this.solicitudId)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            this._clientFirmaLog.subidaOk(this.solicitudId, 'tramite-instancia-general');
            let tramite: TramiteEmvs = {
              id: +this.solicitudId,
              estadoFirma: EstadoTramite.FIRMADO_CON_REGISTRO,
              estado: true,
              procedimiento_id: { id: this.procedimiento.id },
            };
            this.mostrarSpinnerMsg("Registrando el trámite...");
            this._solicitudEmvsService.updateEstadoTramite(tramite)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (data) => {
                  releaseFirmaSubmitLock(this);
                  this._router.navigate(["/perfil"], {
                    queryParams: { action: 30 },
                  });
                  this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
                  this.listadoTramitesService.tramite = null;
                  this.ocultarSpinner();
                },
                error: (error) => {
                  releaseFirmaSubmitLock(this);
                  this.ocultarSpinner();
                },
              });
          },
          error: (err) => {
            releaseFirmaSubmitLock(this);
            this._clientFirmaLog.subidaError(this.solicitudId, 'tramite-instancia-general', err?.message);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
            this._router.navigate(["/inicio"]);
          },
        });
    } else {
      this._clientFirmaLog.error(this.solicitudId, 'tramite-instancia-general', undefined, errorFirma || 'Firma cancelada o fallida');
      this.mostrarSpinnerMsg("Guardando datos completados...");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_FIRMAR_DOCUMENTO', 5000);
      /*       this._servicioGeneral
              .generatePdf(this.tramite.id)
              
                .pipe(takeUntil(this.destroy$))
                .subscribe((data: any) => {
                formDoc.addControl("pdfNoFirmado", new FormControl(), {
                  emitEvent: false,
                });
                formDoc.controls["pdfNoFirmado"].setValue(
                  {
                    nameDocument: "comprobante_solicitud_tramite_.pdf",
                    typeDocument: "application/pdf",
                    b64Document: data.file,
                    csv: this.CSV,
                  },
                  { emitEvent: false }
                ); */
      /*           this._solicitudEmvsService
                  .savePdf(formDoc.controls["pdfNoFirmado"].value, this.solicitudId)
                  
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                    next: (data) => { */
      let tramite: TramiteEmvs = {
        id: +this.solicitudId,
        estadoFirma: EstadoTramite.PENDIENTE_DE_FIRMA,
        estado: true,
      };
      forkJoin([
        this._solicitudEmvsService.updateTramite(tramite),
        this._servicioUsuario.clearCurrentTipoFirma()
      ]).pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            releaseFirmaSubmitLock(this);
            this._router
              .navigate(["/perfil"], { queryParams: { action: 30 } })
              .then(() => {
                this.ocultarSpinner();
              });
          },
          error: () => {
            releaseFirmaSubmitLock(this);
            this._router
              .navigate(["/perfil"], { queryParams: { action: 30 } })
              .then(() => {
                this.ocultarSpinner();
              });
          }
        });
      /*               },
                    error: (err) => {
                      this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                      this._router.navigate(["/inicio"]).then(() => {
                        this.ocultarSpinner();
                      });
                    },
                  }); */
      /*  }); */
    }
  }

  public downloadPdf(base64Document, fileName) {
    if (base64Document) {
      const source = "data:application/pdf;base64," + base64Document;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    if (file) {
      reader.readAsBinaryString(file);
      reader.onload = (event) =>
        result.next(btoa(event.target.result.toString()));
    }
    return result;
  }

  handleUpload(event) {
    const file = event.target.files[0];
    const maxSize = 30 * 1024 * 1024; // 30 MB en bytes
    if (file.size > maxSize) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_FICHERO_NO_PUEDE_PESAR_MAS_DE_30_MB');
      return;
    }
    this.convertFile(file)
      .pipe(takeUntil(this.destroy$))
      .subscribe((base64) => {
        let document = {
          nameDocument: event.target.files[0].name,
          typeDocument: event.target.files[0].type,
          b64Document: base64,
          tramite: this.solicitudId,
          idNextCloud: null,
        };
        this.mapDocumentos.push(document);
      });
  }

  removeFile(index: number): void {
    this.mapDocumentos.splice(index, 1);
  }

  addPuestoArray(): void {
    this.arrayAuxPuestos = this.denominacionPuesto.filter((denominacion) =>
      this.formPuestos
        .get("puesto")
      ["controls"].find(
        (control) =>
          denominacion.id == control["controls"]["denominacion"].value
      )
    );
  }

  deleteTramite() {
    const nombre = this.procedimiento?.nombre || '';
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar trámite',
        message: `¿Seguro que quieres eliminar el trámite «${nombre}»? El trámite quedará dado de baja.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.confirmDelete();
      });
  }

  confirmDelete() {
    if (this.solicitudId != "") {
      this.listadoTramitesService.deleteTramiteForm(this.tramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._router.navigate(["/inicio"]);
            //this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        });
    } else {
      this._notificationI18n.success('NOTIFICATION.MESSAGE.HA_SALIDO_DEL_TRAMITE_CON_EXITO');
      this._router.navigate(["/inicio"]);
    }
  }
  enableAutoSave() {
    const DEBOUNCE_TIME = 500;

    this.formPuestos
      .get("puesto")
      .valueChanges.pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((puesto) => {
          for (const item of puesto) {
            let denominacion;
            if (typeof item.denominacion === "object") {
              denominacion = item.denominacion;
            } else {
              denominacion =
                this.denominacionPuesto.find(
                  (value) => value.id == item.denominacion
                ) ?? this.denominacionPuesto[0];
            }
            item.denominacion = {
              id: denominacion.id,
              nombre: denominacion.nombre,
              puesto: denominacion.puesto,
            };
          }
        }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .savePuesto(
                new PuestoEmvs(
                  value,
                  { id: this.solicitudId },
                  this.puestoModel?.id,
                  this.puestoModel?.idDocumento1,
                  this.puestoModel?.idDocumento2
                )
              )

              .pipe(takeUntil(this.destroy$))
              .subscribe((puesto) => {
                this.puestoModel = {
                  id: puesto.id,
                  idDocumento1: puesto.idDocumento1,
                  idDocumento2: puesto.idDocumento2,
                };
                for (let [index, control] of this.formPuestos
                  .get("puesto")
                ["controls"].entries()) {
                  if (!control["controls"]["id"]) {
                    control.addControl("id", new FormControl(""), {
                      emitEvent: false,
                    });
                    control["controls"]["id"].patchValue(
                      puesto.solicitudes[index].id,
                      { emitEvent: false }
                    );
                  }
                }
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formRepresentante.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((value: any) => {
          value["provincia_representado"] =
            value["provincia_representado"] &&
              value["provincia_representado"].toString().match("[0-9]{1,2}")
              ? { id: value["provincia_representado"] }
              : value["provincia_representado"]
                ? value["provincia_representado"]
                : null;
          value["tipo_via_representado"] =
            value["tipo_via_representado"] &&
              value["tipo_via_representado"].toString().match("[0-9]{1,4}")
              ? { id: value["tipo_via_representado"] }
              : value["tipo_via_representado"]
                ? value["tipo_via_representado"]
                : null;
          value["municipio_representado"] = value["municipio_representado"]
            ? value["municipio_representado"]
            : null;
          return value;
        }),
        concatMap((value: any) =>
          of(
            this._solicitudEmvsService
              .saveRepresentado({
                ...value,
                id: this.representanteId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((representado) => {
                this.representanteId = representado["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formRepresentanteReducido.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((value: any) => {
          value["provincia_representado"] =
            value["provincia_representado"] &&
              value["provincia_representado"].toString().match("[0-9]{1,2}")
              ? { id: value["provincia_representado"] }
              : value["provincia_representado"]
                ? value["provincia_representado"]
                : null;
          value["tipo_via_representado"] =
            value["tipo_via_representado"] &&
              value["tipo_via_representado"].toString().match("[0-9]{1,4}")
              ? { id: value["tipo_via_representado"] }
              : value["tipo_via_representado"]
                ? value["tipo_via_representado"]
                : null;
          value["municipio_representado"] = value["municipio_representado"]
            ? value["municipio_representado"]
            : null;
          return value;
        }),
        concatMap((value: any) =>
          of(
            this._solicitudEmvsService
              .saveRepresentado({
                ...value,
                id: this.representanteId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((representado) => {
                this.representanteId = representado["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formInstancia.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((value) => { }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveInstancia({
                ...value,
                id: this.instanciaId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((instancia) => {
                this.instanciaId = instancia["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formCircunstancias.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveCircunstanciasEmvs({
                ...value,
                id: this.circustanciaId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((circustancia) => {
                this.circustanciaId = circustancia["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formUnidadFamiliar
      .get("familiar")
      .valueChanges.pipe(
        filter(() => (this.formUnidadFamiliar.get("familiar") as FormArray).valid),
        tap((unidad) => {
          for (const item of unidad) {
            item["tramite"] = { id: this.solicitudId };
            let estadoCivil =
              this.estadosCiviles.find(
                (value) => value.id == item["estado_civil"]
              ) ?? this.estadosCiviles[0];
            item["estado_civil"]
              ? (item["estado_civil"] = {
                id: estadoCivil.id,
                nombre: estadoCivil.nombre,
              })
              : (item["estado_civil"] = null);

            let gradoDiscapacidad =
              this.gradosDiscapacidad.find(
                (value) => value.id == item["grado_discapacidad"]
              ) ?? this.gradosDiscapacidad[0];
            item["grado_discapacidad"]
              ? (item["grado_discapacidad"] = {
                id: gradoDiscapacidad.id,
                nombre: gradoDiscapacidad.nombre,
              })
              : (item["grado_discapacidad"] = null);

            let gradoDependencia =
              this.gradosDependencia.find(
                (value) => value.id == item["grado_dependencia"]
              ) ?? this.gradosDependencia[0];
            item["grado_dependencia"]
              ? (item["grado_dependencia"] = {
                id: gradoDependencia.id,
                nombre: gradoDependencia.nombre,
              })
              : (item["grado_dependencia"] = null);
          }
        }),
        concatMap((value) =>
          of(
            value.length > 0
              ? this._solicitudEmvsService
                .saveUnidadFamiliar(value)

                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (tramite) => {
                    for (let [index, control] of this.formUnidadFamiliar
                      .get("familiar")
                    ["controls"].entries()) {
                      if (!control["controls"]["id"]) {
                        control.addControl("id", new FormControl(""), {
                          emitEvent: false,
                        });
                        control["controls"]["id"].patchValue(
                          tramite["unidades"][index]["id"],
                          { emitEvent: false }
                        );
                      }
                    }
                  },
                  error: (error) => {
                    if (error && error.error && (error.error.responseError || error.error.message)) {
                      this._notificationI18n.errorDynamic(error.error.responseError ?? error.error.message, 5000);
                    }
                  }
                })
              : ""
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formDistritos.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveDistritos({
                ...value,
                id: this.distritoId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((distrito) => {
                this.distritoId = distrito["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formVulnerabilidad.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveVulnerabilidad({
                ...value,
                id: this.vulnerabilidadId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((vulnerabilidad) => {
                this.vulnerabilidadId = vulnerabilidad["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formFicheros.valueChanges
      .pipe
      // TODO
      ()

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formAutorizacion.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((value) => {
          for (const autorizacion of value["autorizacion"]) {
            autorizacion["tramite"] = { id: this.solicitudId };
            let estadoCivil = this.estadosCiviles.find(
              (value) => value.id == autorizacion["estado_civil"]
            ) ?? { id: 1, nombre: "Soltero/a" };
            autorizacion["estado_civil"] = {
              id: estadoCivil.id,
              nombre: estadoCivil.nombre,
            };
          }
        }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveAutorizacion(value["autorizacion"])

              .pipe(takeUntil(this.destroy$))
              .subscribe((autorizacion) => {
                for (let [index, control] of this.formAutorizacion
                  .get("autorizacion")
                ["controls"].entries()) {
                  if (!control["controls"]["id"]) {
                    control.addControl("id", new FormControl(""), {
                      emitEvent: false,
                    });
                    control["controls"]["id"].patchValue(
                      autorizacion[index]["id"],
                      { emitEvent: false }
                    );
                  }
                }
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
  restorePersonales() {
    if (this.procedimiento.id === 1) this.restoreRepresentacionReducida();
    if (this.procedimiento.id === 2) this.restoreRepresentacion();
  }
  restoreRepresentacion() {
    this._solicitudEmvsService
      .getRepresentadoByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value.body) {
          this.representanteId = value.body["id"];
          this.representante = value.body;
          if (
            this.representante["provincia_representado"] &&
            this.representante["municipio_representado"]
          ) {
            const idProvincia = this.representante["provincia_representado"].id;
            const idMunicipio = this.representante["municipio_representado"];
            this.getMunicipiosByID(idProvincia);
            this.formRepresentante.patchValue(
              {
                ...this.representante,
                provincia_representado: idProvincia,
                municipio_representado: idMunicipio,
              },
              { emitEvent: false, onlySelf: true }
            );
          } else if (this.representante["municipio_representado"]) {
            const idProvincia = this.representante["provincia_representado"].id;
            this.getMunicipiosByID(idProvincia);
            this.formRepresentante.patchValue(
              { ...this.representante, provincia_representado: idProvincia },
              { emitEvent: false, onlySelf: true }
            );
          } else {
            this.formRepresentante.patchValue(
              { ...this.representante },
              { emitEvent: false }
            );
          }
        }
      });
  }
  restoreRepresentacionReducida() {
    this.getVias();
    this._solicitudEmvsService
      .getRepresentadoByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value.body) {
          this.representanteId = value.body["id"];
          this.representante = value.body;
          if (
            this.representante["provincia_representado"] &&
            this.representante["municipio_representado"]
          ) {
            const idProvincia = this.representante["provincia_representado"].id;
            const idMunicipio = this.representante["municipio_representado"];
            this.getMunicipiosByID(idProvincia);
            this.formRepresentanteReducido.patchValue(
              {
                ...this.representante,
                provincia_representado: idProvincia,
                municipio_representado: idMunicipio,
              },
              { emitEvent: false, onlySelf: true }
            );
          } else if (this.representante["municipio_representado"]) {
            const idProvincia = this.representante["provincia_representado"].id;
            this.getMunicipiosByID(idProvincia);
            this.formRepresentanteReducido.patchValue(
              { ...this.representante, provincia_representado: idProvincia },
              { emitEvent: false, onlySelf: true }
            );
          } else {
            this.formRepresentanteReducido.patchValue(
              { ...this.representante },
              { emitEvent: false }
            );
          }
        }
      });
  }
  restorePoliticas() {
    //TODO paso final 3 formulario

    if (this.procedimiento.id == 3) {
      this.restorePuestos();
    } else {
      this.restoreInstancia();
      this.restoreFicherosAdjuntos();
    }
  }
  restoreFicherosAdjuntos() {


    this._solicitudEmvsService.getDocAdjuntosByIdTramite(this.solicitudId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: any) => {
          for (const documento of value.documentos) {
            this._solicitudEmvsService.getByIdNexcloud(documento.id_gestor_documental)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (value: any) => {
                  this.mapDocumentos.push({ nameDocument: value.documento, idNextCloud: documento.id_gestor_documental })
                  console.log(this.mapDocumentos);
                },
                error: (err) => {

                },
              })
          }


        },
        error: (err) => {

        },
      })
  }
  restoreInstancia() {
    //TODO paso final 1 formulario
    this._solicitudEmvsService
      .getInstanciaByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value.body) {
          this.instanciaId = value.body["id"];
          this.formInstancia.patchValue(
            { ...value.body },
            { emitEvent: false }
          );
        }
      });
    this.restoreRepresentacionReducida();
  }

  restorePuestos() {
    this.getOrdenConvocatoria();
    this.getDenominacionPuesto();
    this._solicitudEmvsService
      .getPuestosByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value: HttpResponse<any>) => {
        if (value.body && value?.body["Puesto"]) {
          this.puestoModel = {
            id: value?.body["Puesto"]["id"],
            idDocumento1: value?.body["Puesto"]["idDocumento1"],
            idDocumento2: value?.body["Puesto"]["idDocumento2"],
          };
          this.restoreDocumentosPuestos(
            value.body["Puesto"]["idDocumento1"],
            value.body["Puesto"]["idDocumento2"]
          );
          if (value.body["Puesto"]["solicitudes"].length > 0) {
            const puestos = value.body["Puesto"]["solicitudes"];
            this.puesto.clear();
            for (const solicitudes of puestos) {
              this.puesto.push(
                new FormGroup({
                  id: new FormControl(solicitudes.id),
                  convocatoria: new FormControl(solicitudes?.convocatoria),
                  denominacion: new FormControl(solicitudes?.denominacion?.id, [
                    Validators.required,
                  ]),
                }),
                { emitEvent: false }
              );
            }
          }
        }
      });
    this.addPuestoArray();
  }



  restoreFicheros() {
    //TODO
    this._solicitudEmvsService.getFicheros(this.solicitudId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: any) => {
          for (const documento of value.documentos) {
            this._solicitudEmvsService
              .getByIdNexcloud(documento.id_gestor_documental)

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (value: any) => {
                  this.arrayFicheros.push({ nameDocument: value.documento });
                },
                error: (err) => { },
              });
          }
        },
        error: (err) => { },
      });
  }

  restoreConsulta() {
    //TODO paso final 2 formulario
  }

  restoreDocumentosPuestos(idDocumento1: string, idDocumento2: string) {
    if (idDocumento1) {
      this._solicitudEmvsService.getByIdNexcloud(idDocumento1)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value: any) => {
            this.formPuestos.patchValue(
              { documento: value.documento },
              { emitEvent: false }
            );
            this.nombreFilePuesto1 = value.documento;
          },
          error: (err) => { },
        });
    }
    if (idDocumento2) {
      this._solicitudEmvsService.getByIdNexcloud(idDocumento2)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value: any) => {
            this.formPuestos.patchValue(
              { documento2: value.documento },
              { emitEvent: false }
            );
            this.nombreFilePuesto2 = value.documento;
          },
          error: (err) => { },
        });
    }
  }

  esNavegable(tabComprobar: string): string {
    if (!this.lastVisitedTab) return "nav-link disabled";
    if (tabComprobar === this.lastVisitedTab) return "nav-link";

    const indexActual: number = this.tabsComprobar.indexOf(this.lastVisitedTab);
    const indexComprobar: number = this.tabsComprobar.indexOf(tabComprobar);

    return (
      indexActual > indexComprobar &&
      !this.submitConsulta &&
      !this.isSigning
    )
      ? "nav-link"
      : "nav-link disabled";
  }
  restauraPestaniaSeleccionada(tabRestaurar: string) {
    if (tabRestaurar && this.restauraPestania) {
      if (!this.solicitudId) {
        this.solicitudId = this.tramite.id.toString();
      }
      if (this.tabRestoreBehavior) this.tabRestoreBehavior[tabRestaurar]();
      this.lastVisitedTab = tabRestaurar;
      this.restauraPestania = true;
      // Sincroniza el .active del DOM con el modelo: limpia cualquier
      // .active residual que Bootstrap haya dejado en otro nav-link.
      const els = document.getElementsByClassName("nav-link");
      Array.prototype.forEach.call(els, (el: Element) => {
        if (el.id !== tabRestaurar) el.classList.remove("active");
      });
    } else if (!this.restauraPestania) {
      this.restauraPestania = true;
    }
  }
  public customPatternValid(config: any): ValidatorFn {
    return (control: FormControl) => {
      let urlRegEx: RegExp = config.pattern;
      if (control.value && !control.value.match(urlRegEx)) {
        return {
          invalidMsg: config.msg,
        };
      } else {
        return null;
      }
    };
  }
  volver() {
    if (
      this.lastVisitedTab != "" &&
      this.lastVisitedTab != undefined &&
      this.tabsComprobar.indexOf(this.lastVisitedTab) > 0
    ) {
      var tab =
        this.tabsComprobar[this.tabsComprobar.indexOf(this.lastVisitedTab) - 1];
      document.getElementById(tab).click();
      //if(tab)this.tabRestoreBehavior[tab]();;
    }
  }
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('tramite_instancia_general_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('tramite_instancia_general_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('tramite_instancia_general_spinner');
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }

  public pdfProcedimientoClave(rId: string, accion: string) {
    //this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');
    if (accion == "firmar") {
      this.uploadDocuments = true;
      this._claveService.getResultFirma(rId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (data.status && data.status == "658") {
              let tramite: TramiteEmvs = {
                id: +this.solicitudId,
                estadoFirma: EstadoTramite.FIRMADO_CON_REGISTRO,
                estado: true,
                procedimiento_id: { id: this.procedimiento.id },
                firmarClave: true,
              };
              this.mostrarSpinnerMsg("Registrando el trámite...");
              this._solicitudEmvsService.updateEstadoTramite(tramite)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (data: any) => {
                    this.downloadPdf(
                      data.pdfFirmado,
                      "comprobante_solicitud_tramite"
                    );
                    setTimeout(() => {
                      this._router.navigate(["/perfil"], {
                        queryParams: { action: 30 },
                      });
                    }, 2000);
                    this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
                    this.uploadDocuments = false;
                    this.listadoTramitesService.tramite = null;
                    this.ocultarSpinner();
                  },
                  error: (error) => {
                    this.ocultarSpinner();
                  },
                });
            }
          },
          error: (error) => { },
        });
    }
  }
}
